export default function Table({ breakpoints, palette, spacing }) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: palette.background.paper
        }
      }
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          UserSelect: 'none !important',
          '&:last-child, &:last-child td': {
            borderBottom: 0 //* avoid last child orphan divider
          }
          // '&.Mui-selected': {
          // backgroundColor: palette.action.selected,
          // '&:hover': {
          //   backgroundColor: palette.action.hover
          // }
          // },
          // th: {
          // paddingRight: 16,
          // paddingLeft: 16
          // }
        }
      }
    },

    // Attention, TableCell est override dans GlobalStyles.js

    MuiTableCell: {
      styleOverrides: {
        root: {
          // overflow: 'hidden'
        },
        head: {
          color: palette.text.secondary,
          borderTop: `1px solid ${palette.divider}`
        },
        stickyHeader: {
          borderTop: `1px solid ${palette.divider}`,
          borderBottom: `1px solid ${palette.divider}`
        },
        body: {
          borderColor: palette.divider
          // height: '1px' // CSS trick : Ce hack permet de mettre un enfant en height: 100% car pour cela, le parent doit avoir une hauteur définie
        }
      }
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          borderColor: palette.divider,
          // backgroundColor: 'inherit',
          // paddingTop: `${spacing(0.5)} !important`,
          // paddingBottom: `${spacing(0.5)} !important`,
          // [breakpoints.up('sm')]: {
          //   paddingTop: `${spacing(1)} !important`,
          //   paddingBottom: `${spacing(1)} !important`
          // },
          paddingRight: breakpoints.down('sm') ? `${spacing(0.5)} !important` : `0 !important`,
          paddingLeft: breakpoints.down('sm') ? `${spacing(0.5)} !important` : `0 !important`
        },
        head: {
          // color: palette.text.secondary,
          // borderTop: `1px solid ${palette.divider}`
          // th: {
          backgroundColor: 'inherit' // table cells have a default white background
          //   borderColor: 'red'
          // }
        },
        // stickyHeader: {
        //   borderTop: `1px solid ${palette.divider}`,
        //   borderBottom: `1px solid ${palette.divider}`
        // },
        body: {
          // CSS trick : Ce hack permet de mettre un enfant
          // en height: 100 % car pour cela, le parent doit avoir une hauteur définie
          height: '1px'
          // borderBottom: `1px solid ${palette.divider}`
          // th: {
          //   borderBottom: `1px solid ${palette.divider}`
          // },
          // tr: {
          //   td: {
          //     borderBottom: `1px solid ${palette.divider}`
          //   }
          // }
        }
      }
    }

    //   MuiTablePagination: {
    //     styleOverrides: {
    //       root: {
    //         borderTop: `solid 1px ${palette.divider}`,
    //         padding: 0,
    //         margin: 0,
    //         UserSelect: 'none !important'
    //       },
    //       toolbar: {
    //         paddingLeft: spacing(1),
    //         flexWrap: 'wrap',
    //         // le tricks suivant permet de passer sur 2 lignes sur small samrtphones
    //         // sans intervenir dans le composant MUI
    //         '&:before': {
    //           content: "''",
    //           display: 'flex',
    //           order: 3,
    //           flexGrow: 1,
    //           width: '100%',
    //           [breakpoints.up('sm')]: { width: 'auto' }
    //         },
    //         '.MuiTablePagination-selectLabel': {
    //           order: 1
    //         },
    //         '.MuiInputBase-root': {
    //           order: 2,
    //           marginRight: `${spacing(2)} !important`
    //         },
    //         '.MuiTablePagination-displayedRows': {
    //           order: 4
    //         },
    //         '.MuiTablePagination-actions': {
    //           order: 5
    //         }
    //       },
    //       actions: {
    //         marginLeft: 0
    //       },
    //       select: {
    //         '&:focus': {
    //           borderRadius: shape.borderRadius
    //         }
    //       },
    //       selectIcon: {
    //         width: 15,
    //         height: 15,
    //         marginTop: 2
    //       }
    //     }
    //   }
  };
}
